<template>
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clip-rule="evenodd"
      d="M11.0925 3.09996C11.4519 2.30001 12.5481 2.30001 12.9075 3.09996L15.1203 8.02508L21.1205 8.79554C21.9503 8.90209 22.2961 9.95459 21.702 10.565L17.5695 14.8101L18.3875 20.1572C18.5166 21.0015 17.6626 21.6373 16.9331 21.2399L12 18.5526L7.06686 21.2399C6.33739 21.6373 5.48337 21.0015 5.61253 20.1572L6.43049 14.8101L2.29804 10.565C1.70386 9.95459 2.04973 8.90209 2.87952 8.79554L8.87967 8.02508L11.0925 3.09996ZM12 5.58801L10.3482 9.26445C10.2024 9.58886 9.90601 9.81258 9.56366 9.85654L4.81161 10.4667L8.02612 13.7689C8.25524 14.0042 8.36112 14.3397 8.31057 14.6701L7.68627 18.7512L11.5346 16.6548C11.826 16.496 12.174 16.496 12.4654 16.6548L16.3137 18.7512L15.6894 14.6701C15.6389 14.3397 15.7448 14.0042 15.9739 13.7689L19.1884 10.4667L14.4363 9.85654C14.094 9.81258 13.7976 9.58887 13.6518 9.26445L12 5.58801Z"
      fill="currentColor"
      fill-rule="evenodd"
    />
  </svg>
</template>
